import React from 'react';
import Slider from 'components/commercetools-ui/atoms/slider';
import MilestoneTile from './milestone-tile';
import type { Milestone } from './types';

/** How many milestones the desktop rule shows at once. */
const SLIDES_PER_VIEW = 4;

/**
 * The company timeline. Two layouts, and both are in the DOM — the swap is CSS, not JS, so the
 * server and the client render the same markup and there is nothing to mismatch on hydration.
 *
 * - **lg and up** — a horizontal rule with a 4-up slider of milestones riding on it.
 * - **below lg** — a vertical rule with every milestone stacked down it.
 */
export default function Timeline({ milestones }: { milestones: Milestone[] }) {
  if (!milestones.length) return null;

  return (
    <div className="relative h-full w-full">
      <div className="hidden lg:block">
        <div className="absolute top-1/2 -mt-2 h-4 w-full bg-primary-black" />
        <Slider
          slidesPerView={SLIDES_PER_VIEW}
          slidesPerGroup={1}
          dots={false}
          // 15 milestones never fit four at a time, but a shorter timeline would.
          arrows={milestones.length > SLIDES_PER_VIEW}
          allowArrowsOnTouchDevice
          allowTouchMove
          spaceBetween={0}
          containerClassName="h-[15rem] 3xl:h-[20rem]"
          prevButtonStyles={{ left: 0, zIndex: 10 }}
          nextButtonStyles={{ right: 0, zIndex: 10 }}
          prevArrowStyles={{ borderWidth: '0 4px 4px 0', borderColor: '#090909' }}
          nextArrowStyles={{ borderWidth: '0 4px 4px 0', borderColor: '#090909' }}
        >
          {milestones.map((milestone, index) => (
            <MilestoneTile key={index} milestone={milestone} milestones={milestones} index={index} />
          ))}
        </Slider>
      </div>

      <div className="lg:hidden">
        {/* The rule stops short of the last image so it does not run past the final milestone. */}
        <div className="absolute left-88 top-24 h-[calc(100%-100px)] w-4 bg-primary-black" />
        <div className="flex flex-col">
          {milestones.map((milestone, index) => (
            <MilestoneTile key={index} milestone={milestone} milestones={milestones} index={index} />
          ))}
        </div>
      </div>
    </div>
  );
}
